import { t } from 'i18next';
import { Rocket } from 'lucide-react';

import { kizeoMessaging } from '@/app/routes/embed/kizeo/messaging';
import { Button, type ButtonProps } from '@/components/ui/button';

type UpgradeButtonProps = {
  size?: ButtonProps['size'];
};

export const UpgradeButton = ({ size }: UpgradeButtonProps = {}) => {
  return (
    <Button
      size={size}
      className="w-full bg-[#55c96b] enabled:hover:bg-[#55c96b]/95 text-[#001438]"
      onClick={() => kizeoMessaging.sendOpenBusinessModalMessage()}
    >
      <Rocket className="h-4 w-4 shrink-0 mr-2" />
      {t('Upgrade to Business plan')}
    </Button>
  );
};
